import React from "react";
import { Font } from "utils/constant";
import parse from "html-react-parser";
import styles from "../styles.module.css";
import { AlertMessage } from "interface/alert";
import { t } from "i18next";

function Notification({ notifications }: { notifications: AlertMessage[] }) {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				gap: "24px",
				fontStyle: "italic",
				fontSize: "16px",
				fontFamily: Font.Roboto,
				padding: "20px",
				paddingBottom: "30px",
				paddingTop: "10px",
			}}
		>
			<div style={{ textAlign: "center", marginBottom: "-10px" }}>
				{" "}
				{t("Alerts")}
			</div>
			<div className="divider"></div>
			{notifications.map((alert, index) => (
				<div key={index}>
					<span>
						<img
							src={"/icon/info.svg"}
							alt="information"
							style={{ width: "16px", height: "16px" }}
						/>
					</span>
					<span> {parse(alert.sqlTxt)}</span>
				</div>
			))}
		</div>
	);
}

export default Notification;
